<template>
    <div>
        <sweet-modal blocking :title="operation === 'create' ? $t('modal_setMeeting') : $t('modal_editMeeting')" ref="setMeeting" class="modal" v-on:close="closeModal">
          <div class="generated-number">
            {{ operation === 'create' ? $t('modal_meeting_idWillBeGeneratedAfterCreateMeeting') : $t('project_tab_meetings_first_card_roomId') + ': ' + form.roomVideoId }}
          </div>
          <el-form :rules="rules" :model="form" status-icon ref="form" class="demo-ruleForm" size="mini">
            <el-row>
              <el-form-item prop="name">
                   <el-input :label="$t('modal_name')" v-model="form.name"></el-input>
              </el-form-item>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item prop="startDate">
                            <el-date-picker
                                    format="d MMM yy"
                                    v-model="form.startDate"
                                    type="date"
                                    value-format="ddMMyyyy"
                                    :placeholder="$t('modal_startDate')"
                                    :picker-options="pickerOptions"
                                    style="width: 100%;"
                                    @change="setStartDate">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item prop="startTime">
                            <el-time-select
                                    v-model="form.startTime"
                                    :picker-options="{
                                            minTime: countMinTimeStartMeeting(form.startDate),
                                            start: '00:00',
                                            step: '00:15',
                                            end: '24:00'
                                          }"
                                    :placeholder="$t('modal_startTime')"
                                    @change="setStartTime"
                                    style="width: 100%;">
                            </el-time-select>
                        </el-form-item>
                    </el-col>
                  <el-col :span="8">
                    <el-form-item prop="meetingDuration">
                      <el-time-select
                          v-model="form.meetingDuration"
                          :picker-options="{
                                            start: '00:05',
                                            step: '00:10',
                                            end: '24:00'
                                          }"
                          :placeholder="$t('modal_meetingDuration')"
                          style="width: 100%;">
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item prop="hostId">
                            <el-select :disabled="operation === 'update'" no-data-text="no date" @change="selectHost" v-model="form.hostId" :placeholder="$t('modal_meeting_host')" style="width: 100%;">
                                <el-option
                                        v-for="item in form.hosts"
                                        :key="item.id"
                                        :label="item.user.fullName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item prop="teamId">
                            <el-select :disabled="operation === 'update'" no-data-text="no date" v-model="form.teamId" multiple :placeholder="$t('modal_team')" style="width: 100%;">
                                <el-option
                                        v-for="item in form.team"
                                        :key="item.id"
                                        :label="item.user.fullName"
                                        :value="item.id"
                                        >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item prop="record">
                      <el-select disabled no-data-text="no date" v-model="form.record" :placeholder="$t('modal_meeting_record')" style="width: 100%;">
                        <el-option
                            v-for="item in form.records"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item v-if="meetingType === 1 || meetingType === 2 || meetingType === 3" prop="clients">
                      <el-select multiple no-data-text="no date" v-model="form.clients" :placeholder="$t('modal_meeting_clients')" style="width: 100%;">
                        <el-option
                            v-for="item in clientsList"
                            :key="item.companyClientId"
                            :label="item.companyClient.name"
                            :value="item.companyClientId">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item v-else prop="clients">
                      <el-select multiple no-data-text="no date" v-model="form.clients" :placeholder="$t('modal_meeting_clients')" style="width: 100%;">
                        <el-option
                            v-for="item in clientsPersonsList"
                            :key="item.companyClientPersonId"
                            :label="item.companyClientPerson.fullName"
                            :value="item.companyClientPersonId">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item v-if="meetingType === 1 || meetingType === 2 || meetingType === 3" prop="vendors">
                      <el-select  multiple no-data-text="no date" v-model="form.vendors" :placeholder="$t('modal_meeting_vendors')" style="width: 100%;">
                        <el-option
                            v-for="item in vendorsList"
                            :key="item.companyVendorId"
                            :label="item.companyVendor.name"
                            :value="item.companyVendorId">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item v-else prop="vendors">
                        <el-select  multiple no-data-text="no date" v-model="form.vendors" :placeholder="$t('modal_meeting_vendors')" style="width: 100%;">
                            <el-option
                                    v-for="item in vendorsPersonsList"
                                    :key="item.companyVendorPersonId"
                                    :label="item.companyVendorPerson.fullName"
                                    :value="item.companyVendorPersonId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                    <el-form-item prop="purpose" :label="$t('modal_meeting_meetingPurpose')" class="textarea-block">
                      <div>
                        <vue2-custom-editor
                            ref="editorPurpose"
                            v-model="form.purpose">
                        </vue2-custom-editor>
                      </div>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item prop="agenda" :label="$t('modal_meeting_meetingAgenda')" class="textarea-block">
                        <vue2-custom-editor
                            ref="editorAgenda"
                            v-model="form.agenda">
                        </vue2-custom-editor>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item>
                        <label for="file-meeting" class="file-meeting">
                            <i class="el-icon-upload"></i>
                            {{$t('modal_meeting_uploadFile')}}
                        </label>
                        <input ref='fileMeeting' v-show="false" @change="handleFile" id="file-meeting" name="my-file-meeting" type="file">
                        <div v-for="(list, index) in fileList" :key="list.id" class="file__item">
                          <div class="file__name" style="cursor:pointer;"><span class="file__item_order">{{index + 1}}</span>{{list.name || list.originalName}}</div>
                          <div class="file__delete" @click="deleteFile(list, operation)"><i class="el-icon-close"></i></div>
                        </div>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-checkbox v-model="form.setReminder" @change="selectReminder">{{$t('modal_meeting_setReminder')}}</el-checkbox>
                </el-row>
                <el-row v-if="form.setReminder">
                  <el-form-item prop="reminderTime" class="reminder-time-block">
                    <el-date-picker
                        :disabled="!form.startDate && !form.startTime"
                        v-model="form.reminderTime"
                        :picker-options="reminderTimePickerOptions"
                        ref="reminderTimePicker"
                        value-format="ddMMyyyyHH:mm"
                        @change="selectTimePickerReminder"
                        type="datetime">
                    </el-date-picker>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-checkbox v-model="form.allowTeamJoinMeeting">{{$t('modal_meeting_allowTeamJoinMeetingBeforeStartAction')}}</el-checkbox>
                </el-row>
                <!--{{fileList}}-->
                <el-form-item class="modal__btn">
                    <el-button @click="modalCancel('setMeeting')">{{$t('general_cancel')}}</el-button>
                    <el-button v-if="operation === 'create'" @click="setMeetingSubmit('form')" type="primary">{{$t('general_submit')}}</el-button>
                    <el-button v-else @click="editMeetingSubmit('form')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
        <!--VIEWER-->
        <div v-if="viewerType == 1">
            <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
                <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
            </sweet-modal>
        </div>
        <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="{movable: true}">
                <img :src="fileUrl" :key="fileUrl" />
            </div>
        </div>
        <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'video'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
        <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'audio'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
    </div>
</template>

<script>
  import Media from '@dongido/vue-viaudio'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import { VueEditor } from 'vue2-editor'
  import axios from 'axios'
  import moment from 'moment'
  import Vue2CustomEditor from "../../vue-2-custom-editor";
  export default  {
    name:'create--project--meeting--modal',
    computed:{

    },
    components:{
      Vue2CustomEditor,
      SweetModal,
      Media,
      VueEditor
    },
    props: {
      meetingType: {
        type: Number,
        default: 1
      },
      fileMeetingType: {
        type: Number,
        default: 1
      },
      vendorsList: {
          type: Array,
          default: () => ([])
      },
      clientsList: {
          type: Array,
          default: () => ([])
      },
      vendorsPersonsList: {
          type: Array,
          default: () => ([])
      },
      clientsPersonsList: {
          type: Array,
          default: () => ([])
      },
      page: {
        type: Number,
        default: 1
      }
    },
    data(){
      return{
        taskId: null,
        form:{
          name: '',
          startDate:'',
          startTime: '',
          record: null,
          records: ['Yes', 'No'],
          hostId: null,
          teamId: [],
          meetingDuration: null,
          clients: [],
          clientList: [],
          vendors: [],
          hosts: [],
          team: [],
          purpose: '',
          agenda: '',
          setReminder: false,
          allowTeamJoinMeeting: false,
          reminderTime: null,
          roomVideoId: null
        },
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Number(moment().subtract(1, 'days').format('x'));
          },
        },
        reminderTimePickerOptions: {
          format: 'HH:mm',
          selectableRange: '00:00:00-23:59:59',
          disabledDate: this.disabledReminderTimePicker
        },
        rules: {
          name: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          startDate: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          startTime: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          hostId: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          teamId: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'blur'
          }],
          meetingDuration: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'blur'
          }],
          // teamId: [{ validator: validateTeamId, trigger: 'blur' }],
          purpose: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          reminderTime: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
        },
        selectedMeetingId: '',
        operation: 'create',
        fileList: [],
        deletedId: '',
        viewerType: 0,
        fileUrl: '',
        type: '',
        companyUserList: []
      }
    },
    methods:{
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      openModal(operation, meetingId){
        this.operation = operation;
        if(meetingId){
          this.selectedMeetingId = meetingId
        }
        let url = `/api/v1/meetings/directories?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.projectId || this.$route.query.businessUnitId || this.$route.query.engagementId}&operation=${operation}&taskId=${this.taskId}&typeId=${this.meetingType}`;
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(url)
          .then(response => {
            this.companyUserList = response.data.companyUserList.sort(this.compare)
            this.form.team = response.data.companyUserList.sort(this.compare)
            this.form.hosts = response.data.companyUserList.sort(this.compare)
            if(this.operation === 'update' && this.selectedMeetingId){
              this.getItemMeeting(this.selectedMeetingId)
            }
            this.$nextTick(()=> {
              this.$refs.editorPurpose.setImagesState()
              this.$refs.editorAgenda.setImagesState()
            })
            this.$refs.setMeeting.open();
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          })

      },
      getItemMeeting(meetingId){
        let loader = this.$loading.show();
        let url = `/api/v1/meetings/item?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.projectId || this.$route.query.businessUnitId || this.$route.query.engagementId}&meetingId=${meetingId}&taskId=${this.taskId}&typeId=${this.meetingType}`
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(url)
          .then(response => {
            let startDate = moment(response.data.item.startTimestamp.toString(), 'X').format( 'DDMMYYYY' )
            let startTime = moment(response.data.item.startTimestamp.toString(), 'X').format( 'HH: mm' )
            console.log(startTime)
            this.form.name = response.data.item.name
            this.form.startDate = startDate
            this.form.startTime = startTime
            this.form.hostId = response.data.item.hostId
            this.form.teamId = response.data.item.companyUserIdList.filter(val => val !== response.data.item.hostId)
            this.form.purpose = response.data.item.purpose
            this.form.agenda = response.data.item.agenda
            this.form.roomVideoId = response.data.item.roomVideoId
            this.fileList = response.data.item.meetingFiles
            this.form.setReminder = response.data.item.setReminder
            this.form.reminderTime = response.data.item.reminderTime ? moment(response.data.item.reminderTime.toString(), 'X').format('DDMMYYYYHH:mm') : null
            this.form.team = this.form.team.filter(val => val.id !== this.form.hostId)
            this.form.allowTeamJoinMeeting = response.data.item.allowTeamJoinMeeting === 1
            this.form.meetingDuration = this.secondsToHms(response.data.item.meetingDuration)
            this.form.vendors = response.data.item.vendorsList
            this.form.clients = response.data.item.clientsList
            this.$nextTick(()=> {
              this.$refs.editorPurpose.setImagesState()
              this.$refs.editorAgenda.setImagesState()
            })
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          })
      },
      setStartDate(date) {
        const currentDate = moment().format('DDMMYYYY')

        if (date === currentDate && this.form.startTime) {
          const currentTime = moment().format('HH:mm')
          if (Number(moment(this.form.startTime, 'HH:mm').format('x')) <=
              Number(moment(currentTime, 'HH:mm').format('x'))) {
            this.form.startTime = ''
          }
        }
        // handle reminder time
        this.setReminderTimeTimeRange(date, this.form.startTime)
        // reset reminder
        this.form.reminderTime = null
      },
      setStartTime(val){
        this.setReminderTimeTimeRange(this.form.startDate, val)
        // reset reminder
        this.form.reminderTime = null
      },
      countMinTimeStartMeeting(selectedDate){
        const currentDate = moment().format('DDMMYYYY')
        const currentTime = moment().format('HH:mm')
        if (selectedDate === currentDate) {
          // const currentTime = moment().format('HH:mm')
          // console.log('currentTime', currentTime)

          // get last 2 chars from current time
          const lastTwoNums = parseInt(currentTime.slice(-2));
          switch (true) {
            case (lastTwoNums < 15):
              return currentTime.slice(0, -1).replace(/.$/,"15")
            case (lastTwoNums < 30):
              return currentTime.slice(0, -1).replace(/.$/,"30")
            case (lastTwoNums < 45):
              return currentTime.slice(0, -1).replace(/.$/,"45")
            default:
              return moment(currentTime, 'HH:mm').add(1, 'hours').format('HH:mm').slice(0, -1).replace(/.$/,"00")
          }
        } else {
          return false
        }
      },
      selectTimePickerReminder(val) {
        console.log('selectTimePickerReminder', val)
      },
      selectHost(val) {
        this.form.teamId = this.form.teamId.filter(b => b !== val)
        this.form.team = this.companyUserList.filter(i => i.id !== val)
      },
      addHost(val) {
        const ifExist = this.form.teamId.find(item => item === val);
        if (!ifExist) {
          this.form.teamId.push(val)
        }
      },
      removeTeamUser(userId) {
        if(this.form.hostId === userId) {
          this.form.hostId = null
        }
      },
      setReminderTimeTimeRange(date, time) {
        console.log('date, time', date, time)
        if (date && time) {
          const currentDate = moment().format('DDMMYYYY')
          const currentTime = moment().format('HH:mm:00')
          const times = this.reminderTimePickerOptions.selectableRange.split('-')
          // handle current date and currentDate
          if (date === currentDate) {
            times[0] = moment(currentTime, 'HH:mm:ss').add(15, 'minutes').format('HH:mm:00')
            times[1] = moment(time, 'HH:mm:ss').subtract(15, "minutes").format('HH:mm:00')
          } else {
            // handle selected date in calendar
            times[0] = '00:00:00'
            times[1] = '23:59:59'
          }
          this.reminderTimePickerOptions.selectableRange = times.join('-')
        }
        console.log('this.reminderTimePickerOptions.selectableRange', this.reminderTimePickerOptions.selectableRange)
      },
      disabledReminderTimePicker(time){
        const start = time.getTime() < Date.now() - 8.64e7;
        let end = false
        if (this.form.startDate) {
          end = time.getTime() > Number(moment(this.form.startDate, 'DDMMYYYY').format('x'))
        }
        if (start){
          return start
        }else if(end){
          return end
        }
      },
      closeModal(){
        // this.taskId = '';
        this.form.name = '';
        this.form.startDate = '';
        this.form.startTime = '';
        this.form.record = null
        this.form.hostId = null;
        this.form.teamId = [];
        this.form.team = [];
        // this.form.fileUrl = '';
        this.form.clients = [];
        this.form.clientList = [];
        this.form.vendors = [];
        this.form.purpose = '';
        this.form.agenda = '';
        this.form.setReminder = false;
        this.form.reminderTime = null;
        this.selectedMeetingId = '';
        this.fileList = [];
        this.deletedId = '';
        this.form.roomVideoId = null;
        this.companyUserList = [];
        this.form.allowTeamJoinMeeting = false;
        this.form.meetingDuration = null;
        this.$refs['form'].resetFields();
      },
      closeMod() {
        this.viewerType = 0;
      },
      setMeetingSubmit(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            // put host into the team
            this.addHost(this.form.hostId)
            let time = moment(this.form.startTime, 'hh:mm').format('HHmm');
            let startTimestamp = moment(this.form.startDate + time, 'DDMMYYYYHHmm').format('X');
            const duration = moment.duration(this.form.meetingDuration)
            const seconds =  parseInt(Math.floor(duration._milliseconds / 1000));

            let data = {
              name: this.form.name,
              startTimestamp: startTimestamp,
              hostId: this.form.hostId,
              companyUserIdList: this.form.teamId,
              purpose: this.form.purpose,
              agenda: this.form.agenda,
              reminderTime: this.form.reminderTime ? moment(this.form.reminderTime, 'DDMMYYYYHH:mm').format('X') : null,
              // fileName: this.fileList.length && this.form.fileUrl ? this.fileList[0].name : null,
              setReminder: this.form.setReminder,
              meetingDuration: seconds,
              allowTeamJoinMeeting: this.form.allowTeamJoinMeeting ? 1 : 0,
              vendorsList:  this.form.vendors,
              clientsList:  this.form.clients
            };
            let url = `/api/v1/meetings/create?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.projectId || this.$route.query.businessUnitId || this.$route.query.engagementId}&taskId=${this.taskId}&typeId=${this.meetingType}`;
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(url, data)
              .then(response => {
                if (this.$refs.editorPurpose.uploadedImagesArray.length || this.$refs.editorAgenda.uploadedImagesArray.length) {
                  this.$store.dispatch('approveUploadedImages', {
                    fileUrlArr: this.$refs.editorPurpose.uploadedImagesArray.concat(this.$refs.editorAgenda.uploadedImagesArray),
                    entityId: response.data.meetingId,
                    entityTypeId: this.setEntityTypeId(this.meetingType)
                  })
                }
                loader.hide()
                console.log('---/projects/item', response.data);
                if (this.fileList.length) {
                  this.createFiles(this.fileList, response.data.meetingId)
                } else {
                  this.$store.dispatch('getMeetings', {
                    companyId: this.$route.query.companyId,
                    parentId: this.$route.query.projectId || this.$route.query.businessUnitId || this.$route.query.engagementId,
                    taskId: this.taskId,
                    typeId: this.meetingType,
                    page: this.page
                  })
                }
                this.$refs.setMeeting.close();
                this.notification(this.$t('general_success'), this.$t('notification_createMeeting'), "success");
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      setEntityTypeId(meetingType) {
        switch (meetingType) {
          case 1:
            return 5
          case 2:
            return 21
          case 3:
            return 13
          case 4:
            return 29
          case 5:
            return 47
          case 6:
            return 38
        }
      },
      editMeetingSubmit(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            // put host into the team
            this.addHost(this.form.hostId)
            let time = moment(this.form.startTime, 'hh:mm').format('HHmm')
            let startTimestamp = moment(this.form.startDate + time, 'DDMMYYYYHHmm').format('X')
            const duration = moment.duration(this.form.meetingDuration)
            const seconds =  parseInt(Math.floor(duration._milliseconds / 1000));
            let data = {
              name: this.form.name,
              startTimestamp: startTimestamp,
              hostId: this.form.hostId,
              companyUserIdList: this.form.teamId,
              purpose: this.form.purpose,
              agenda: this.form.agenda,
              reminderTime: this.form.reminderTime ? moment(this.form.reminderTime, 'DDMMYYYYHH:mm').format('X') : null,
              setReminder: this.form.setReminder,
              meetingDuration: seconds,
              allowTeamJoinMeeting: this.form.allowTeamJoinMeeting ? 1 : 0,
              vendorsList:  this.form.vendors,
              clientsList:  this.form.clients
            }
            let url = `/api/v1/meetings/update?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.projectId || this.$route.query.businessUnitId || this.$route.query.engagementId}&meetingId=${this.selectedMeetingId}&taskId=${this.taskId}&typeId=${this.meetingType}`
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(url, data)
              .then(response => {
                if (this.$refs.editorPurpose.uploadedImagesArray.length || this.$refs.editorAgenda.uploadedImagesArray.length) {
                  this.$store.dispatch('approveUploadedImages', {
                    fileUrlArr: this.$refs.editorPurpose.uploadedImagesArray.concat(this.$refs.editorAgenda.uploadedImagesArray),
                    entityId: this.selectedMeetingId,
                    entityTypeId: this.setEntityTypeId(this.meetingType)
                  })
                }

                if (this.$refs.editorPurpose.removedImages.length || this.$refs.editorAgenda.removedImages.length) {
                  this.$store.dispatch('deleteRemovedImages', this.$refs.editorPurpose.removedImages.concat(this.$refs.editorAgenda.removedImages))
                }

                loader.hide()
                console.log('---/projects/item', response.data.item);
                this.createFiles(this.fileList, this.selectedMeetingId)
                this.$store.dispatch('getMeetings', {
                  companyId: this.$route.query.companyId,
                  parentId: this.$route.query.projectId || this.$route.query.businessUnitId || this.$route.query.engagementId,
                  taskId: this.taskId,
                  typeId: this.meetingType,
                  page: this.page
                })
                this.$refs.setMeeting.close();
                this.notification(this.$t('general_success'), this.$t('notification_updateMeeting'), "success");
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      async createFiles(fileList, meetingId) {
        let formData = new FormData();

        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].url) {
            formData.append('file', fileList[i].fileId);
          }else {
            formData.append('file', fileList[i]);
          }
        }
        const url = `/api/v1/meeting-file/createArr?companyId=${this.$route.query.companyId}&typeId=${this.fileMeetingType}&meetingId=${meetingId}`
        const updateUrl = `/api/v1/meeting-file/updateArr?companyId=${this.$route.query.companyId}&typeId=${this.fileMeetingType}&meetingId=${meetingId}`

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(this.operation === 'create' ? url : updateUrl,
                formData,
                {'Content-Type': 'multipart/form-data'})
            .then(response => {
              this.fileList = []
              this.$store.dispatch('getMeetings', {
                companyId: this.$route.query.companyId,
                parentId: this.$route.query.projectId || this.$route.query.businessUnitId || this.$route.query.engagementId,
                taskId: this.taskId,
                typeId: this.meetingType,
                page: this.page
              })
              loader.hide();
            })
            .catch(error => {
              this.fileList = []
              this.$store.dispatch('getMeetings', {
                companyId: this.$route.query.companyId,
                parentId: this.$route.query.projectId || this.$route.query.businessUnitId || this.$route.query.engagementId,
                taskId: this.taskId,
                typeId: this.meetingType,
                page: this.page
              })
              loader.hide()
            })
      },
      async createFileFromUrl(url, fileName, fileFormat){
        let response = await fetch(url);
        let data = await response.blob();
        let metadata = {
          type: fileFormat
        };
        let file = new File([data], fileName, metadata);
        return file
      },
      handleFile(e) {
        let file = e.target.files[0];
        this.fileList.push(file);
        console.log('---', this.fileList);
        this.$refs.fileMeeting.value = '';
      },
      deleteFile(file, type) {
        let index = this.fileList.indexOf(file);
        if (index !== -1) {
          this.fileList.splice(index, 1);
        }

        if (type == 'update') {
          if (this.deletedId.length > 0) {
            this.deletedId = this.deletedId + ',' + file.id
          } else {
            this.deletedId = this.deletedId + file.id
          }
        }
      },
      selectReminder(val){
        if (!val) this.form.reminderTime = null;
      },
      viewFile(url){
        console.log(url)
        let type = url.split('.').pop().toUpperCase()
        if (type == 'GIF' || type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP' || type == 'OGG' || type == 'MP4' || type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A' || type == 'PDF' || type === 'XLS' || type === 'DOCX' || type === 'DOC' || type === 'XLSX') {
          this.fileUrl = url;
          this.type = this.fileUrl.split('.').pop().toUpperCase();
          console.log('---', this.fileUrl, this.type);

          if (type == 'GIF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP') {
            this.viewerType = 2;
            setTimeout(() => {
              console.log('-----', this.$el);
              const viewer = this.$el.querySelector('.images').$viewer
              viewer.show()
            }, 300);
          } else if (type == 'OGG' || type == 'MP4') {
            this.viewerType = 3;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A') {
            this.viewerType = 4;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (type == 'PDF') {
            this.viewerType = 1;
            this.fileUrl = process.env.VUE_APP_TF_PDF_VIEWER_BASE_URL + '/?file=' + this.fileUrl;
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          } else if (type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF') {
            // this.viewerType = 1;
            this.fileUrl = 'https://sharecad.org/cadframe/load?url=' + this.fileUrl;
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          }else if (type === 'XLS' || type === 'DOCX' || type === 'DOC' || type === 'XLSX'){
            const win = window.open(`https://view.officeapps.live.com/op/view.aspx?src=${this.fileUrl}`, '_blank');
            win.focus();
          }
        }
      },
      compare( a, b ) {
        if ( a.user.firstname < b.user.firstname ){
          return -1;
        }
        if ( a.user.firstname > b.user.firstname){
          return 1;
        }
        return 0;
      },
      pad(num) {
        return ("0"+num).slice(-2);
      },
      secondsToHms(secs) {
        let minutes = Math.floor(secs / 60);
        secs = secs%60;
        let hours = Math.floor(minutes/60)
        minutes = minutes%60;
        return `${this.pad(hours)}:${this.pad(minutes)}`;
        // return pad(hours)+":"+pad(minutes)+":"+pad(secs); for old browsers
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      }
    },
    watch: {
      'form.reminderTime': function (val) {
        const currentDate = moment().format('DDMMYYYY')
        const currentTime = moment().format('HH:mm:00')
        const times = this.reminderTimePickerOptions.selectableRange.split('-')
        // handle if user set reminder not today and in meeting day
        if (this.form.startDate === moment(val, 'DDMMYYYYHH:mm').format('DDMMYYYY') && currentDate !== this.form.startDate) {
          times[0] = '00:00:00'
          times[1] = moment(this.form.startTime, 'HH:mm').subtract(15, "minutes").format('HH:mm:00')
          // handle if user set reminder today and in meeting day
        } else if (this.form.startDate === moment(val, 'DDMMYYYYHH:mm').format('DDMMYYYY') && currentDate === this.form.startDate) {
          times[0] = moment(currentTime, 'HH:mm:ss').add(15, 'minutes').format('HH:mm:00')
          times[1] = moment(this.form.startTime, 'HH:mm').subtract(15, "minutes").format('HH:mm:00')
          // handle not today and in another day
        } else {
          times[0] = '00:00:00'
          times[1] = '23:59:59'
        }
        this.reminderTimePickerOptions.selectableRange = times.join('-')
        // console.log('/./././', this.form.startDate)
        // console.log('/./././', this.form.startTime)
        // console.log('MA VALLLL', val)
        // console.log('MA VALLLL', times)
      }
    }
  }
</script>

<style lang="less" scoped>
    .generated-number {
      position: absolute;
      right: 50px;
      top: 50px;
    }
    .sweet-modal-overlay{
        z-index:1000;
    }
    .center{
        display:flex;
        justify-content:center;
     }
    .textarea-block {
      margin-top:30px;
        /deep/.el-form-item__label {
          top: -5px;
          position: absolute;
        }
    }
    .file {
        cursor: pointer;
        &__item {
            display: flex;
            align-items: center;
            &_order{
              margin-right: 10px;
              font-weight: bold;
            }
            &__viewed{
                display:flex;
                align-items:center;
                cursor:pointer;
            }
            &__not-loaded{
                display:flex;
                align-items:center;
            }
        }
        &__name {
            margin-right: 10px;
        }
        &__delete {
            color: red;
            cursor: pointer;
        }
    }
</style>
